module.exports = __webpack_public_path__ + "static/media/green-texture.224811d9.jpg";